module.exports = __webpack_public_path__ + "img/2013-4.95d1b745.jpg";